import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from '../../../axios-backend';
import BackButton from '../../main/BackButton';
import ColorPicker from './ColorPicker';

const ShopProduct = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    // All hooks must be called before any conditional returns
    const [colorCombination, setColorCombination] = useState([]);
    const [colorPicker, setColorPicker] = useState();

    // Get state values safely
    const state = location.state || {};
    const { areaAmount, type, gender, size } = state;

    Cookies.set("scrollPositionPD", 0);
    useEffect(() => {
        // Redirect if no state
        if (!location.state) {
            navigate('/');
            return;
        }

        if (colorCombination.length === parseInt(areaAmount)) {
            const tempColor = `{${colorCombination.join(',')}}`;
            axios.get('/getProductIdByColor/', {
                params: { gender, typeId: type, color: tempColor, size }
            }).then((data) => {
                if (data.data.status === 200) {
                    navigate('/products/productdetails', {
                        state: { productId: data.data.id, type, gender, areaAmount, size }
                    });
                }
            });
        } else {
            setColorPicker(<ColorPicker type={type} gender={gender} size={size} {...{ colorCombination }} onChoseColor={setColorCombination} {...{ areaAmount }} {...props} />);
        }
    }, [colorCombination, areaAmount, gender, type, size, navigate, location.state, props]);

    // Early return if no state
    if (!location.state) {
        return null;
    }

    return (
        <>
            <BackButton />
            {colorPicker}
        </>
    );
}
export default ShopProduct;
